
  (function () {
    const KLAVIYO_SITE_ID = "V4GME6";

    /**
     * Hittar den valda Shopify-varianten.
     *
     * Först försöker vi läsa variantfältet från produktens
     * Add to Cart-formulär. Om det inte går använder vi
     * variant-ID:t som sparades i notification-elementet.
     */
    function getSelectedVariantId(notificationElement) {
      const section = notificationElement.closest(
        ".shopify-section, [data-section-id], section"
      );

      let productForm = null;

      if (section) {
        productForm = section.querySelector(
          'form[action*="/cart/add"]'
        );
      }

      if (!productForm) {
        productForm = document.querySelector(
          'form[action*="/cart/add"]'
        );
      }

      if (productForm) {
        const variantInput = productForm.querySelector(
          'input[name="id"], select[name="id"]'
        );

        if (variantInput && variantInput.value) {
          return String(variantInput.value).trim();
        }
      }

      return String(
        notificationElement.getAttribute(
          "data-initial-variant-id"
        ) || ""
      ).trim();
    }


    /**
     * Visar meddelande i notification-rutan.
     */
    function showMessage(messageElement, text, type) {
      messageElement.hidden = false;
      messageElement.textContent = text;

      messageElement.classList.remove(
        "is-success",
        "is-error",
        "is-loading"
      );

      if (type) {
        messageElement.classList.add(type);
      }
    }


    /**
     * Skickar Back in Stock-prenumerationen till Klaviyo.
     */
    async function subscribeToBackInStock(notificationElement) {
      const emailInput = notificationElement.querySelector(
        "[data-back-in-stock-email]"
      );

      const submitButton = notificationElement.querySelector(
        "[data-back-in-stock-submit]"
      );

      const messageElement = notificationElement.querySelector(
        "[data-back-in-stock-message]"
      );

      if (!emailInput || !submitButton || !messageElement) {
        console.error(
          "Back in Stock: Ett eller flera HTML-element saknas.",
          {
            emailInput: emailInput,
            submitButton: submitButton,
            messageElement: messageElement
          }
        );

        return;
      }

      const email = emailInput.value.trim();
      const variantId = getSelectedVariantId(
        notificationElement
      );

      /*
       * Använd webbläsarens inbyggda validering för e-postfältet.
       */
      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (!variantId) {
        showMessage(
          messageElement,
          "Kunde inte identifiera den valda varianten.",
          "is-error"
        );

        console.error(
          "Back in Stock: Inget Shopify variant-ID hittades."
        );

        return;
      }

      if (
        !KLAVIYO_SITE_ID ||
        KLAVIYO_SITE_ID === "DIN_RIKTIGA_SITE_ID"
      ) {
        showMessage(
          messageElement,
          "Klaviyo Site ID har inte konfigurerats.",
          "is-error"
        );

        console.error(
          "Back in Stock: Fyll i KLAVIYO_SITE_ID i JavaScript-koden."
        );

        return;
      }

      submitButton.disabled = true;

      showMessage(
        messageElement,
        "Registrerar bevakning...",
        "is-loading"
      );

      const klaviyoVariantId =
        "$shopify:::$default:::" + variantId;

      const payload = {
        data: {
          type: "back-in-stock-subscription",

          attributes: {
            profile: {
              data: {
                type: "profile",

                attributes: {
                  email: email
                }
              }
            },

            channels: [
              "EMAIL"
            ]
          },

          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: klaviyoVariantId
              }
            }
          }
        }
      };

      const endpoint =
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/" +
        "?company_id=" +
        encodeURIComponent(KLAVIYO_SITE_ID);

      console.log("Klaviyo Back in Stock request:", {
        endpoint: endpoint,
        email: email,
        shopifyVariantId: variantId,
        klaviyoVariantId: klaviyoVariantId,
        payload: payload
      });

      try {
        const response = await fetch(endpoint, {
          method: "POST",

          mode: "cors",

          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "revision": "2026-07-15"
          },

          body: JSON.stringify(payload)
        });

        /*
         * Klaviyo svarar normalt med 202 och tom body
         * när registreringen accepteras.
         */
        if (!response.ok) {
          let errorData = null;
          let responseText = "";

          try {
            responseText = await response.text();

            if (responseText) {
              errorData = JSON.parse(responseText);
            }
          } catch (parseError) {
            console.warn(
              "Kunde inte tolka Klaviyos felsvar.",
              parseError
            );
          }

          console.error(
            "Klaviyo Back in Stock API error:",
            {
              status: response.status,
              statusText: response.statusText,
              body: errorData || responseText
            }
          );

          const errorDetail =
            errorData &&
            errorData.errors &&
            errorData.errors[0] &&
            errorData.errors[0].detail;

          throw new Error(
            errorDetail ||
            "Klaviyo svarade med status " +
              response.status +
              "."
          );
        }

        showMessage(
          messageElement,
          "Klart! Vi mejlar dig när produkten är tillbaka i lager.",
          "is-success"
        );

        emailInput.value = "";
      } catch (error) {
        console.error(
          "Klaviyo Back in Stock error:",
          error
        );

        let userMessage =
          "Det gick inte att registrera bevakningen. Försök igen.";

        /*
         * Failed to fetch innebär vanligtvis att webbläsaren
         * blockerade requesten, exempelvis genom CORS, CSP
         * eller ett script/ad-blocker.
         */
        if (
          error &&
          error.message === "Failed to fetch"
        ) {
          userMessage =
            "Anslutningen till Klaviyo misslyckades. Försök igen.";
        } else if (error && error.message) {
          userMessage = error.message;
        }

        showMessage(
          messageElement,
          userMessage,
          "is-error"
        );
      } finally {
        submitButton.disabled = false;
      }
    }


    /**
     * Event delegation.
     *
     * Detta fungerar även om notification-rutan renderas
     * eller öppnas dynamiskt efter sidladdning.
     */
    document.addEventListener(
      "click",
      function (event) {
        const clickedButton = event.target.closest(
          "[data-back-in-stock-submit]"
        );

        if (!clickedButton) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const notificationElement =
          clickedButton.closest("[data-notification]");

        if (!notificationElement) {
          console.error(
            "Back in Stock: Kunde inte hitta notification-elementet."
          );

          return;
        }

        subscribeToBackInStock(
          notificationElement
        );
      }
    );


    /**
     * Gör så att Enter i e-postfältet också registrerar
     * bevakningen utan att produktens varukorgsformulär skickas.
     */
    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key !== "Enter") {
          return;
        }

        const emailInput = event.target.closest(
          "[data-back-in-stock-email]"
        );

        if (!emailInput) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const notificationElement =
          emailInput.closest("[data-notification]");

        if (!notificationElement) {
          return;
        }

        subscribeToBackInStock(
          notificationElement
        );
      }
    );
  })();
